import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import jaCommon from './translations/ja/common.json';
import jaTop from './translations/ja/top.json';
import jaAbout from './translations/ja/about.json';
import jaStudentclub from './translations/ja/studentclub.json';
import jaUsageex from './translations/ja/usageex.json';
import enCommon from './translations/en/common.json';
import enTop from './translations/en/top.json';
import enAbout from './translations/en/about.json';
import enStudentclub from './translations/en/studentclub.json';
import enUsageex from './translations/en/usageex.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      ja: {
        common: jaCommon,
        top: jaTop,
        about: jaAbout,
        studentclub: jaStudentclub,
        usageex: jaUsageex
      },
      en: {
        common: enCommon,
        top: enTop,
        about: enAbout,
        studentclub: enStudentclub,
        usageex: enUsageex
      },
      zh: {
      }
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p', 'span'],
    },
    lng: "ja", // デフォルト言語は日本語
    fallbackLng: "ja", // これにより、未翻訳のキーがある場合にデフォルトの言語にフォールバックする
    interpolation: {
      escapeValue: false
    },
    ns: ["common", "top", "about", "studentclub", "usageex"], // 利用する名前空間
    defaultNS: "common" // デフォルトの名前空間
  });

export default i18n;
